//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'm-column',
  props: [
    'title'
  ],
  computed: {
    borderLeftColor () {
      return 'border-left-color: ' + this.$store.state.config.themeColor
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Column.vue